module.exports = __webpack_public_path__ + "static/media/da-home-3.81d1f787.jpg";